import { useStoreMapContext } from '@components/storeMap/provider/StoreMapContext'
import { useLayoutWithMapOrigin } from '@components/storeMap/utils'
import useHasSystemRole from '@hooks/useHasSystemRole.ts'

function DebugNeighbors() {
  const { data: layout } = useLayoutWithMapOrigin()
  const { selectedShelfId } = useStoreMapContext()

  const isDeveloper = useHasSystemRole('DEVELOPER')
  if (!isDeveloper) return null
  if (!layout || !selectedShelfId) return null

  const selectedShelf = layout.shelves.find(shelf => shelf.id === selectedShelfId)
  const leftNeighbor = layout.shelves.find(shelf => shelf.id === selectedShelf?.leftNeighborShelfId)
  const rightNeighbor = layout.shelves.find(shelf => shelf.id === selectedShelf?.rightNeighborShelfId)

  return (
    <>
      {leftNeighbor && (
        <text
          x={leftNeighbor.center.x}
          y={leftNeighbor.center.y}
          text-anchor="middle"
          dominant-baseline="middle"
          font-size="0.5"
          pointerEvents="none"
        >
          L ({leftNeighbor.id.slice(-3)})
        </text>
      )}
      {rightNeighbor && (
        <text
          x={rightNeighbor.center.x}
          y={rightNeighbor.center.y}
          text-anchor="middle"
          dominant-baseline="middle"
          font-size="0.5"
          pointerEvents="none"
        >
          R ({rightNeighbor.id.slice(-3)})
        </text>
      )}
    </>
  )
}

export default DebugNeighbors